import { Flex } from "@chakra-ui/react";

import type { ReactNode } from "react";
import TravelHero from "@features/services/travel/TravelHero";

const TravelPageLayout = ({
  children,
  gap = 4,
  align,
}: {
  children: ReactNode;
  gap?: number;
  align?: "center";
}) => (
  <Flex flexDirection="column" w="full" h="full" position="relative">
    <TravelHero
      src="/images/travel-landing-customers.jpeg"
      alt="China with Gyasi - Travel"
    />
    <Flex
      flexDirection="column"
      gap={gap}
      p={6}
      maxW="3xl"
      mx="auto"
      w="full"
      align={align}
    >
      {children}
    </Flex>
  </Flex>
);

export default TravelPageLayout;
